import { createAction, props } from '@ngrx/store';

export const enablePersonalDetailsDateOfBirthAction = createAction(
  '[Personal details form] Enable date of birth',
  props<{
    formId: string;
    enabled: boolean;
  }>()
);
